import { Components, Theme } from '@mui/material/styles';
import scssVariables from '@styles/variables.module.scss';

export const MuiFormControlLabel: Components<Theme>['MuiFormControlLabel'] = {
  defaultProps: {
    slotProps: {
      typography: {
        variant: 'bodyRegular',
        color: scssVariables.ColorBlack100,
      },
    },
  },
  styleOverrides: {
    asterisk: {
      color: scssVariables.ColorCoral80,
    },
    label: {
      '&.Mui-disabled': {
        color: scssVariables.ColorBlack60,
      },
    },
  },
};
